import { once } from '../shared/once';

export interface CountryByIso {
    currency: string;
    name: string;
    native: string;
    phoneCode: string;
    states: {
        name: string;
        code: string;
    }[];
    timeZones: string[];
}

export const getCountriesByIso2 = once<Promise<Record<string, CountryByIso>>>(async () => {
    const data = await fetch(`${window.mh.scriptUrl}/assets/countries-by-iso2.json`, {
        method: `GET`,
    });

    if (!data.ok) {
        throw new Error(`Could not obtain countries data. Please check your network connection and refresh the page.`);
    }

    return data.json();
});
